import { Route, Switch } from 'react-router-dom';
import PublicCoursePage from './PublicCoursePage';
import PublicCatalogPage from './PublicCatalogPage';
import PublicLessonPage from './PublicLessonPage';
import CertificationOverviewPage from './CertificationOverviewPage';
import Homepage from './Homepage';
import { Paths } from './RoutingConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Routes = () => /*#__PURE__*/_jsxs(Switch, {
  children: [/*#__PURE__*/_jsx(Route, {
    component: Homepage,
    exact: true,
    path: Paths.HOMEPAGE
  }), /*#__PURE__*/_jsx(Route, {
    component: CertificationOverviewPage,
    exact: true,
    path: Paths.CERTIFICATION_OVERVIEW
  }), /*#__PURE__*/_jsx(Route, {
    component: PublicCatalogPage,
    exact: true,
    path: Paths.CATALOG_PAGE
  }), /*#__PURE__*/_jsx(Route, {
    component: PublicCatalogPage,
    exact: true,
    path: Paths.CATALOG_PAGE_WITH_PAGINATION
  }), /*#__PURE__*/_jsx(Route, {
    component: PublicCatalogPage,
    exact: true,
    path: Paths.CATALOG_PAGE_WITH_PATH_FILTER
  }), /*#__PURE__*/_jsx(Route, {
    component: PublicCatalogPage,
    exact: true,
    path: Paths.CATALOG_PAGE_WITH_PATH_FILTER_AND_PAGINATION
  }), /*#__PURE__*/_jsx(Route, {
    component: PublicCoursePage,
    path: Paths.COURSE_LANDING
  }), /*#__PURE__*/_jsx(Route, {
    component: PublicLessonPage,
    path: Paths.LESSON_LANDING
  })]
});